export default class Banner extends Phaser.GameObjects.Container {
    private sprite!: Phaser.GameObjects.Image;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupSprite();
    }

    setupSprite() {
        let frame = 'gui/friends/banner';

        this.sprite = this.scene.add.image(0, 0, 'atlas', frame);
        this.sprite.setOrigin(0.5, 0);
        this.add(this.sprite);
    }
}
